import { Fieldset, Radio, ValidationMessage } from '@digdir/designsystemet-react';
import { useTranslation } from 'react-i18next';

import { useSolcelleFormContext } from '../utils';

// Capacity is either provided in kWp or in m²
// This radio toggles between kWp input and m² input based on user knowledge of production capacity
export const ProductionCapacityRadio = () => {
  const { t } = useTranslation();
  const { register, formState } = useSolcelleFormContext();
  return (
    <Fieldset>
      <Fieldset.Legend>{t('register.solar.form.productionCapacity.label')}</Fieldset.Legend>
      <Fieldset.Description>{t('register.solar.form.productionCapacity.info')}</Fieldset.Description>
      <Radio
        {...register('hasCapacityData', { required: t('register.solar.form.productionCapacity.error') })}
        label={t('register.solar.form.productionCapacity.yes')}
        value="yes"
      />
      <Radio
        {...register('hasCapacityData', { required: t('register.solar.form.productionCapacity.error') })}
        label={t('register.solar.form.productionCapacity.no')}
        value="no"
      />
      {formState.errors.hasCapacityData && (
        <ValidationMessage data-color="danger">{formState.errors.hasCapacityData.message}</ValidationMessage>
      )}
    </Fieldset>
  );
};
